// export function formatDate(date) {
//     if (!date || !(date instanceof Date)) {
//         return date;
//     }
//     // Get the UTC date components
//     const year = date.getFullYear();
//     const month = date.getMonth() + 1; // getUTCMonth() returns months from 0-11
//     const day = date.getDate();
//     // Format the components into a YYYY-MM-DD string
//     return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
// }

export function formatDate(date) {
    if (!date) {
        return date;
    }
    // If date is a string in YYYY-MM-DD format, parse safely
    if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
        const [year, month, day] = date.split("-").map(Number);
        date = new Date(year, month - 1, day);
    }
    if (!(date instanceof Date)) {
        return date;
    }
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}
